"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactNotifications = require("react-notifications");
var NotificationsContainer = function NotificationsContainer(_ref) {
  var stacked = _ref.stacked;
  var wrapperClasses = (0, _classnames["default"])('notification-container-wrapper', stacked && 'stacked');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/_react["default"].createElement(_reactNotifications.NotificationContainer, null));
};
NotificationsContainer.defaultProps = {
  stacked: false
};
NotificationsContainer.propTypes = {
  stacked: _propTypes["default"].bool
};
var _default = NotificationsContainer;
exports["default"] = _default;